




































































































































































































































































































































































































































import store from "../../store/store";
import { mapGetters, mapState } from "vuex";
import BaseResponsiveTable from "../../components/Base/BaseResponsiveTable.vue";
import BaseWizardSteps from "../../components/Base/BaseWizardSteps.vue";
import BaseBreadcrumb from "@/components/Base/BaseBreadcrumb.vue";
import TheBannerSmall from "@/components/The/TheBannerSmall.vue";
import BasePage from "@/components/Base/BasePage.vue";
import TooltipPrijs from "@/components/TooltipPrijs.vue";
import { i18n } from "@/plugins/i18n";
import TableDynamicSimpel from "@/components/TableDynamicSimpel.vue";
import BestellijstTable from "@/components/BestellijstTable.vue";
import CurrencyFormat from "@/components/CurrencyFormat.vue";
import WeightyFormat from "@/components/WeightFormat.vue";
import BaseIconAlert from "@/components/Base/BaseIconAlert.vue";
import { apiClient } from "@/services/api-client";
import { Guid } from "@/services/guid";

export default {
  name: "BestellenAfronden",
  components: {
    TooltipPrijs,
    BasePage,
    TheBannerSmall,
    BaseBreadcrumb,
    BaseWizardSteps,
    BaseResponsiveTable,
    TableDynamicSimpel,
    BestellijstTable,
    CurrencyFormat,
    WeightyFormat,
    BaseIconAlert
  },
  data() {
    return {
      gegevens: this.$store.state.bestellen.form,
      isValidated: false,
      serverSideBestellijstError: true
    };
  },
  created() {
    apiClient
      .checkServerSideBestellijstStatus({
        materieellocatie: this.$store.getters.selectedLocationId,
        gebruikerLogin: this.$store.getters.getUsername,
        bestelijstId: this.$store.getters.getSelectedBestellijst
          ? this.$store.getters.getSelectedBestellijst.id
          : Guid.Empty
      })
      .then(response => {
        this.serverSideBestellijstError = response.hasItems;
      });
  },
  computed: {
    voorwaardenAccepted: {
      get() {
        return this.$store.state.bestellen.voorwaardenAccepted;
      },
      set(value) {
        this.$store.commit("setVoorwaardenAccepted", value);
      }
    },
    ...mapState({
      selectedLocation: (state: any) => state.location.selectedLocation
    }),
    ...mapGetters([
      "bestellijstItems",
      "bestellijstChildren",
      "bestellijstParents",
      "selectedLocationId",
      "bestellijstTotaleAantal",
      "bestellijstTotaleHuurprijs",
      "bestellijstTotaleHuurprijsWeek",
      "bestellijstTotaleVerkoopprijs",
      "getBoolSetting",
      "getMultiSetting",
      "getIntSetting",
      "locationChanged",
      "getColumnSetting",
      "bestellijstTotaleGewicht",
      "selectedLocationApprovalRequired"
    ]),

    fields() {
      return [
        {
          key: this.SetKeyKolomnSoortNummer,
          label: this.$t("shared.nummer"),
          order: this.getColumnSetting("BestellenAfronden_MaterieelSoort")
            .order,
          sortable: true
        },
        {
          key: this.SetKeyKolomnOmschrijving,
          label: this.$t("shared.omschrijving"),
          order: this.getColumnSetting("BestellenAfronden_Omschrijving").order,
          sortable: true
        },
        {
          key: this.SetKeyKolomnOpmerking,
          label: this.$t("shared.opmerking"),
          order: this.getColumnSetting("BestellenAfronden_Opmerking").order
        },
        {
          key: this.SetKeyKolomnHuurPrijs,
          label: this.$t("shared.huurprijs"),
          order: this.getColumnSetting("BestellenAfronden_Huurprijs").order
        },
        {
          key: this.SetKeyKolomnVerkoopPrijs,
          label: this.$t("shared.verkoopprijs"),
          order: this.getColumnSetting("BestellenAfronden_Verkoopprijs").order
        },
        {
          key: this.SetKeyKolomnGewicht,
          label: this.$t("shared.gewicht"),
          order: this.getColumnSetting("BestellenAfronden_Gewicht").order
        },
        {
          key: this.SetKeyKolomnAantal,
          order: this.getColumnSetting("BestellenAfronden_Aantal").order,
          label: this.$t("shared.aantal")
        }
      ];
    },

    SetKeyKolomnSoortNummer() {
      return this.getColumnSetting("BestellenAfronden_MaterieelSoort").isEnabled
        ? "materieelSoort"
        : null;
    },
    SetKeyKolomnOmschrijving() {
      return this.getColumnSetting("BestellenAfronden_Omschrijving").isEnabled
        ? "omschrijving"
        : null;
    },
    SetKeyKolomnOpmerking() {
      return this.getColumnSetting("BestellenAfronden_Opmerking").isEnabled
        ? "opmerking"
        : null;
    },
    SetKeyKolomnHuurPrijs() {
      return this.getColumnSetting("BestellenAfronden_Huurprijs").isEnabled
        ? this.showDayPrice
          ? "huurPrijs"
          : "huurPrijsWeek"
        : null;
    },
    SetKeyKolomnVerkoopPrijs() {
      return this.getColumnSetting("BestellenAfronden_Verkoopprijs").isEnabled
        ? "verkoopPrijs"
        : null;
    },
    SetKeyKolomnGewicht() {
      return this.getColumnSetting("BestellenAfronden_Gewicht").isEnabled
        ? "gewichtPerStuk"
        : null;
    },
    SetKeyKolomnAantal() {
      return this.getColumnSetting("BestellenAfronden_Aantal").isEnabled
        ? "aantal"
        : null;
    },

    showDayPrice() {
      return this.getMultiSetting("Materieel_ShowDayPrice");
    },
    showWeekPrice() {
      return this.getMultiSetting("Materieel_ShowWeekPrice");
    },

    toonGewicht() {
      return this.getColumnSetting("BestellenAfronden_Gewicht").isEnabled;
    },
    calcPrice() {
      return this.getBoolSetting("PrijsPerAantal");
    },
    calcGewicht() {
      return this.getBoolSetting("GewichtPerAantal");
    },
    showApprover() {
      return (
        this.getBoolSetting("Bestellen_EnableAanvraagGoedkeuren") &&
        this.getBoolSetting("Bestellen_EnableMeerdereBestellijsten") &&
        this.selectedLocationApprovalRequired
      );
    }
  },
  methods: {
    getTranslation(item) {
      if (item.vertalingen && item.vertalingen.hasOwnProperty(i18n.locale)) {
        return item.vertalingen[i18n.locale];
      }

      return item.omschrijving;
    },
    boolSetting(settingName) {
      return this.getBoolSetting(settingName);
    },
    getParentClass(index) {
      return { "item-parent": index !== 0 };
    },
    redirectToList() {
      this.$store.dispatch("redirected");
      this.$router.push({ name: "Bestellijst" });
    }
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch("redirected");

    if (!store.state.bestellen.bestelgegevensIngevuld) {
      next({ name: "BestellenGegevens" });
      return;
    }
    next();
  }
};
